// extracted by mini-css-extract-plugin
export var colorSquare = "_sz-0";
export var danger = "_sz-5";
export var lightPink = "_sz-8";
export var neutralBlue = "_sz-7";
export var neutralYellow = "_sz-6";
export var normal = "_sz-1";
export var primary = "_sz-2";
export var primaryLight = "_sz-3";
export var solidBlack = "_sz-g";
export var solidGreen = "_sz-b";
export var solidLightBlue = "_sz-d";
export var solidNavy = "_sz-c";
export var solidOrange = "_sz-f";
export var solidPink = "_sz-e";
export var solidRed = "_sz-9";
export var solidYellow = "_sz-a";
export var success = "_sz-4";